import {Paginazione} from "../shared/models/paginazione";
import {Prodotto} from "../Progetti/Models/Prodotto";
import {Azienda} from "../Admin/models/Azienda";

export class Listino {
  id?:number;
  data?: string;
  nominativo?: string;
  id_fornitore?: number;
  prodotti: Prodotto[];
  fornitoreObject: Azienda;
  enabled?: boolean;
}

export class Filter extends Paginazione {
  last?: boolean;
  fornitore?: string;
  id?:number;
  constructor(page?, size?,last?,fornitore?) {
    super(page ?? 0, size ?? 10);
    this.last = last ?? true;
    this.fornitore = fornitore;
  }
}

export class ProdottoListino {
  id?: number;
  id_listino?: number;
  id_prodotto?: number;
  prezzo?:number;
  codice_produttore?:string;
  note?:string;
  aggiunte?: Aggiunta[];
  prodottoObject?: Prodotto
  codiceAdhoc?: any;
  constructor(id?) {
    this.aggiunte = [];
    this.id_listino = id;
  }
}

export class Aggiunta{
  nome?:string;
  prezzo?: number;
  modifica?: boolean;
  backup?: Aggiunta;
  selected?: boolean;
  constructor() {
    this.modifica = true;
  }
}
